import styled from 'styled-components'

export const StopOnInput = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 56px;
  border-radius: 38px;
  border: solid 3px #ffb000;
  margin-top: 15px;
  margin-bottom: 20px;
  align-content: center;
  /* svg {
    width: 11px;
    height: 12px;
    position: absolute;
    right: 10%;
    top: 20px;
  } */
`
